import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Typography, Card } from 'antd';

import { Grid, Row, Col } from 'react-flexbox-grid';

import 'antd/dist/antd.css';

import styles from './Exchanges.css';

import cash from './cash.png';
import coinbase from './coinbase.png';
import gemini from './gemini.png';
import blockfi from './blockfi.png';
import kraken from './kraken.png';
import river from './river.png';
import abra from './abra.png';


const { Title } = Typography;

import { toggleActive, selectCurrent } from './exchangesSlice';

export default function Exchanges() {
  const dispatch = useDispatch();
  const exchanges = useSelector(selectCurrent);

  return (
    <div>
      <div className={styles.container}>
        <div className={styles.header}>
          <Title level={5}>Select Exchanges</Title>
        </div>

        <Grid className={styles.grid} fluid>
          <Row>
            <Col
              key="1"
              className={styles.antCol}
              xs={24}
              sm={12}
              md={12}
              lg={4}
            >
              <Card
                onClick={() => dispatch(toggleActive({ name: 'cash' }))}
                className={`${styles.myDiv} ${
                  exchanges.find((el) => el.name === 'cash').active
                    ? styles.active
                    : null
                }`}
              >
                <img width={150} preview="false" src={cash} />
              </Card>
            </Col>
            <Col
              key="2"
              className={styles.antCol}
              xs={24}
              sm={12}
              md={12}
              lg={4}
            >
              <Card
                onClick={() => dispatch(toggleActive({ name: 'coinbase' }))}
                className={`${styles.myDiv} ${
                  exchanges.find((el) => el.name === 'coinbase').active
                    ? styles.active
                    : null
                }`}
              >
                <img width={150} preview="false" src={coinbase} />
              </Card>
            </Col>
            <Col
              key="3"
              className={styles.antCol}
              xs={24}
              sm={12}
              md={12}
              lg={4}
            >
              <Card
                onClick={() => dispatch(toggleActive({ name: 'gemini' }))}
                className={`${styles.myDiv} ${
                  exchanges.find((el) => el.name === 'gemini').active
                    ? styles.active
                    : null
                }`}
              >
                <img width={150} preview="false" src={gemini} />
              </Card>
            </Col>
          </Row>

          <Row justify="space-around">
            <Col
              key="4"
              className={styles.antCol}
              xs={24}
              sm={12}
              md={12}
              lg={4}
            >
              <Card
                onClick={() => dispatch(toggleActive({ name: 'blockfi' }))}
                className={`${styles.myDiv} ${
                  exchanges.find((el) => el.name === 'blockfi').active
                    ? styles.active
                    : null
                }`}
              >
                <img width={150} preview="false" src={blockfi} />
              </Card>
            </Col>
            <Col
              key="5"
              className={styles.antCol}
              xs={24}
              sm={12}
              md={12}
              lg={4}
            >
              <Card
                onClick={() => dispatch(toggleActive({ name: 'kraken' }))}
                className={`${styles.myDiv} ${
                  exchanges.find((el) => el.name === 'kraken').active
                    ? styles.active
                    : null
                }`}
              >
                <img width={150} preview="false" src={kraken} />
              </Card>
            </Col>
            <Col
                key="6"
                className={styles.antCol}
                xs={24}
                sm={12}
                md={12}
                lg={4}
              >
                <Card
                  onClick={() => dispatch(toggleActive({ name: 'abra' }))}
                  className={`${styles.myDiv} ${
                    exchanges.find((el) => el.name === 'abra').active
                      ? styles.active
                      : null
                  }`}
                >
                  <img width={150} preview="false" src={abra} />
                </Card>
              </Col>
            {/* <Col
                key="6"
                className={styles.antCol}
                xs={24}
                sm={12}
                md={12}
                lg={4}
              >
                <Card
                  onClick={() => dispatch(toggleActive({ name: 'river' }))}
                  className={`${styles.myDiv} ${
                    exchanges.find((el) => el.name === 'river').active
                      ? styles.active
                      : null
                  }`}
                >
                  <img width={150} preview="false" src={river} />
                </Card>
              </Col> */}
          </Row>
        </Grid>
      </div>
    </div>
  );
}
